import React from "react";
import { useNavigate, Navigate } from "react-router";
import { Typography } from "components";
import { FiInfo } from "react-icons/fi";
import { ROUTES } from "routes/routePaths";
import { useSelector } from "react-redux";
import { currentOnboardingStatus } from "utils/helper";
import wavingHand from "assets/images/waving-hand.png";

import guarantorForm from "assets/documnets/guarantorForm.pdf";

const StatusInfo = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);

  const onBoardingStatus = user?.onboarding_state;

  const onBoardingDone = () => localStorage.getItem("onBoardingDone"); //To track if user finished uploading file, we want to be sure we're not showing them statusInfos. Rather, we show them what a status 7 will do

  const getCorrespondingFormAndInfo = () => {
    switch (onBoardingStatus) {
      case 0:
        return {
          onBoardingState: 1,
          bodyToRender: startOnboarding,
        };

      case 1:
        return {
          onBoardingState: 2,
          bodyToRender: continueOnBoarding,
        };

      case 2:
        return {
          onBoardingState: 1,
          bodyToRender: onBoardingError,
        };

      case 3:
        return {
          onBoardingState: 3,
          bodyToRender: continueOnBoarding,
        };

      case 4:
        return {
          onBoardingState: 2,
          bodyToRender: onBoardingError,
        };

      case 5:
        return {
          onBoardingState: 4,
          bodyToRender: continueOnBoarding,
        };

      case 6:
        return {
          onBoardingState: 3,
          bodyToRender: onBoardingError,
        };

      case 8:
        return {
          onBoardingState: 4,
          bodyToRender: onBoardingError,
        };

      case 10:
        return {
          onBoardingState: 1,
          bodyToRender: onBoardingError,
        };

      default:
        return {};
    }
  };

  const startOnboarding = (
    <div className="mt-4 d-flex info-container">
      <span>
        <FiInfo color="#1966FC" fontSize="20px" />
      </span>
      &nbsp; &nbsp; &nbsp;
      <div className="info">
        <Typography variant="body1" state="primary">
          **You are required to update your account information{" "}
          <Typography
            state="secondary"
            component="span"
            variant="body2"
            onClick={() =>
              navigate(ROUTES.agentOnboarding, {
                state: {
                  onBoardingState:
                    getCorrespondingFormAndInfo().onBoardingState,
                },
              })
            }
          >
            {" "}
            here
          </Typography>{" "}
          to get started. Upon provision of your profile information, your
          account will be verified and you would be able to view terminal
          transactions, request for new terminal, manage your account and much
          more.
        </Typography>
        <Typography className="mt-3" state="danger" variant="caption2">
          ** Ensure to upload your guarantor ID card and form to complete your
          registration
        </Typography>

        <a
          href={guarantorForm}
          download="guarantorForm"
          style={{ textDecoration: "none" }}
        >
          <Typography variant="body2" className="mt-2" state="primary">
            Download Guarantor Agreement Form
          </Typography>
        </a>
      </div>
    </div>
  );

  const continueOnBoarding = (
    <div className="mt-4 d-flex info-container">
      <span>
        <FiInfo color="#1966FC" fontSize="20px" />
      </span>
      &nbsp; &nbsp; &nbsp;
      <div className="info">
        <Typography variant="body1" state="primary">
          **Click{" "}
          <Typography
            state="secondary"
            component="span"
            variant="body2"
            onClick={() =>
              navigate(ROUTES.agentOnboarding, {
                state: {
                  onBoardingState:
                    getCorrespondingFormAndInfo().onBoardingState,
                },
              })
            }
          >
            {" "}
            here
          </Typography>{" "}
          to continue your account setup. Upon provision of complete information
          required, your account will be verified and you would be able to
          manage your terminal transactions, request for new terminal and much
          more.
        </Typography>
      </div>
    </div>
  );

  const onBoardingError = (
    <div className="mt-4 d-flex info-container">
      <span>
        <FiInfo color="#DC2C2C" fontSize="20px" />
      </span>
      &nbsp; &nbsp;
      <div className="info">
        <Typography
          variant="body1"
          state="primary"
          component="span"
          style={{ textDecoration: "none" }}
        >
          {onBoardingStatus === 10
            ? `**Unable to verify your account Click`
            : onBoardingStatus === 8
            ? `**Unable to verify your account due to issues with documents uploaded. Click`
            : `**Unable to verify your account because of ${currentOnboardingStatus(
                onBoardingStatus
              )?.label.toLocaleLowerCase()}. Click`}
        </Typography>{" "}
        <Typography
          state="secondary"
          variant="body2"
          component="span"
          onClick={() =>
            navigate(ROUTES.agentOnboarding, {
              state: {
                onBoardingState: getCorrespondingFormAndInfo()?.onBoardingState,
              },
            })
          }
        >
          here
        </Typography>{" "}
        <Typography
          variant="body1"
          state="primary"
          component="span"
          style={{ textDecoration: "none" }}
        >
          to update accordingly
        </Typography>
      </div>
    </div>
  );

  if (onBoardingStatus === 7 || onBoardingDone())
    return <Navigate to={ROUTES.agentOnboardingPending} />; //Account is awaiting approval, disallow edits

  return (
    <div className="new-account-container">
      <Typography variant="heading3" state="primary" component="h3">
        Welcome {user?.corporate_name || user?.firstname}{" "}
        <img src={wavingHand} width="30" alt="" />,
      </Typography>
      {getCorrespondingFormAndInfo().bodyToRender}
    </div>
  );
};

export default StatusInfo;
